import React from 'react'

export default () => (
  <footer className="sticky-footer bg-white">
    {/* <!-- Footer  --> */}
    <div className="container my-auto">
      <div className="copyright text-center my-auto">
        <span>Copyright &copy; SocialBlaze 2020</span>
      </div>
    </div>
    {/* <!-- End of Footer  --> */}
  </footer>
)
